import type { AnalyticsProvider } from '../../AnalyticsManager.types'

export enum MetaEventMethod {
	LOG_PURCHASE = 'logPurchase',
	LOG_EVENT = 'logEvent',
}

export interface MetaEventData {
	eventName: string
	method: MetaEventMethod
	arguments: [string | number | null, Record<string, any>] | [string | number, string | number, Record<string, any>] | [Record<string, any>]
}

export interface MetaDependency {
	sendEvent: (analyticsProvider: AnalyticsProvider, eventData: MetaEventData) => Promise<void>
	isMobileApp: () => boolean
}
